import React from "react";
import IconSvg, { IconSvgProps } from "~/guidelines/Icon/IconSvg";

const Accessible = ({ color }: IconSvgProps) => {
  return (
    <IconSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 2.26953C16.3954 2.26953 15.5 3.16496 15.5 4.26953C15.5 5.3741 16.3954 6.26953 17.5 6.26953C18.6046 6.26953 19.5 5.3741 19.5 4.26953C19.5 3.16496 18.6046 2.26953 17.5 2.26953ZM14.5 16.7295H12.5C12.5 18.3795 11.15 19.7295 9.5 19.7295C7.85 19.7295 6.5 18.3795 6.5 16.7295C6.5 15.0795 7.85 13.7295 9.5 13.7295V11.7295C6.74 11.7295 4.5 13.9695 4.5 16.7295C4.5 19.4895 6.74 21.7295 9.5 21.7295C12.26 21.7295 14.5 19.4895 14.5 16.7295ZM15.64 13.2295H17.5C18.6 13.2295 19.5 14.1295 19.5 15.2295V19.7295C19.5 20.2795 19.05 20.7295 18.5 20.7295C17.95 20.7295 17.5 20.2795 17.5 19.7295V15.7295H12.52C11.06 15.7295 10.07 14.1595 10.67 12.8295L12.5 8.72953H10.29L9.99 9.43953C9.79 9.90953 9.28 10.1595 8.79 10.0195C8.22 9.85953 7.9 9.24953 8.11 8.68953L8.39 7.92953C8.72 7.19953 9.45 6.72953 10.26 6.72953H15.46C16.94 6.72953 17.92 8.22953 17.31 9.55953L15.64 13.2295Z"
        fill="currentColor"
      />
    </IconSvg>
  );
};

export default Accessible;
